/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
import MailIcon from "@mui/icons-material/Mail";

function Footer() {
  return (
    <footer className="footer">
      <p>ladagevandoorn.nl - 2026 </p>
      <a href="mailto:ladagevandoorn@gmail.com">
        <MailIcon className="icon" />
      </a>
    </footer>
  );
}

export default Footer;
